import styled from "styled-components";

export const FilterPlansContainer = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 320px;
`;

export const FilterSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FilterTitle = styled.h3`
  margin: 0;
  font-weight: 900;
  font-size: 16px;
  line-height: 1.2;
  color: rgba(0, 0, 0, 0.85);
`;

export const CheckboxItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const SumInsuredSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const SumInsuredButton = styled.button<{ isSelected?: boolean }>`
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid ${(props) => (props.isSelected ? "#008CFF" : "#E2E2E2")};
  background: ${(props) => (props.isSelected ? "#F8FBFF" : "#FFFFFF")};
  color: ${(props) => (props.isSelected ? "#008CFF" : "#4A4A4A")};
  font-weight: ${(props) => (props.isSelected ? 900 : 400)};
  font-size: 12px;
  line-height: 1.2;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border-color: #008cff;
  }
`;

export const Divider = styled.div`
  height: 1px;
  background: #f2f2f2;
  border: 1px solid #d8d8d8;
`;
